import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import KravTimeApp from './KravTimeApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <KravTimeApp />
  </React.StrictMode>
); 